onInteractive(function() {
	// The CMS derives "sizes" from the ratio attribute, a fraction of the screen width. Header photos are
	// cropped with object-fit: cover to the full viewport height and section photos change width per
	// breakpoint, so that estimate picks a far too small file. Measuring the rendered box (and, for
	// cover crops, the width the photo really needs to fill it) keeps every photo sharp.
	var images = document.querySelectorAll('.page-header img[srcset], .page-image-col img[srcset], .contact-intro-image img[srcset], .page-range img[srcset], .page-social-album img[srcset], .blog-item-preview img[srcset]');
	var updateSizes = function() {
		images.forEach(function(image) {
			// Slides that are not active are hidden, so they are measured by the slider that holds them.
			var box = (image.closest('.carousel-inner') || image).getBoundingClientRect();
			if (box.width === 0) {
				return;
			}
			var needed = box.width;
			var naturalRatio = image.naturalWidth && image.naturalHeight
				? image.naturalWidth / image.naturalHeight
				: parseFloat(image.getAttribute('width')) / parseFloat(image.getAttribute('height'));
			if (getComputedStyle(image).objectFit === 'cover' && naturalRatio) {
				needed = Math.max(box.width, box.height * naturalRatio);
			}
			// The browser picks the file from the <source> elements of the picture, so they need the value too.
			var sizes = Math.ceil(needed) + 'px';
			image.parentElement.querySelectorAll('source[srcset]').forEach(function(source) {
				source.setAttribute('sizes', sizes);
			});
			image.setAttribute('sizes', sizes);
		});
	};
	updateSizes();
	var resizeTimeout = null;
	window.addEventListener('resize', function() {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(updateSizes, 200);
	});
});

onInteractive(function() {
	// Editors must always see and edit the full text, so the collapsed state only exists for visitors.
	if (document.body.hasAttribute('data-editor-mode')) {
		return;
	}

	// Long card texts (the team members on "Over ons") start collapsed, like the old site did.
	// A text that opens with its own heading keeps that heading plus three paragraphs visible;
	// a text whose heading sits outside it (the page title above the module output) keeps two.
	document.querySelectorAll('.page-card').forEach(function(card) {
		var button = card.querySelector('.page-card-readmore');
		var text = card.querySelector('.content-item-content, [data-partial="text"]');
		if (!button || !text) {
			return;
		}

		var blocks = Array.prototype.filter.call(text.children, function(child) {
			return child.textContent.trim() !== '';
		});
		var visibleCount = /^H[1-6]$/.test(blocks.length > 0 ? blocks[0].tagName : '') ? 4 : 2;
		if (blocks.length <= visibleCount) {
			return;
		}

		var hidden = blocks.slice(visibleCount);
		hidden.forEach(function(block) {
			block.setAttribute('hidden', '');
		});
		button.removeAttribute('hidden');
		button.addEventListener('click', function() {
			hidden.forEach(function(block) {
				block.removeAttribute('hidden');
			});
			button.setAttribute('hidden', '');
		});
	});
});

onInteractive(function() {
	// On phones the social buttons hang below the sticky bar. They belong to the top of the page,
	// so they scroll away with it instead of floating over the text underneath.
	var socials = document.querySelector('.navigation-socials');
	if (!socials) {
		return;
	}
	var update = function() {
		if (getComputedStyle(socials).position !== 'absolute') {
			socials.style.transform = '';
			socials.style.clipPath = '';
			return;
		}
		// Clip the part that has moved up past the bottom of the bar, so the buttons slide under it.
		var hiddenTop = Math.max(0, window.scrollY - (socials.offsetTop - socials.offsetParent.offsetHeight));
		socials.style.transform = 'translateY(' + (-window.scrollY) + 'px)';
		socials.style.clipPath = 'inset(' + hiddenTop + 'px 0 0 0)';
	};
	update();
	window.addEventListener('scroll', update, { passive: true });
	window.addEventListener('resize', update);
});
